import { render, staticRenderFns } from "./NAVIGATION.vue?vue&type=template&id=20489dfa&"
import script from "./NAVIGATION.vue?vue&type=script&lang=js&"
export * from "./NAVIGATION.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports